import React from "react";
import PageHeader from "../components/common/PageHeader";
import PageMeta from "../components/common/PageMeta";
import ContactFormThree from "../components/contact/ContactFormThree";
import FooterOne from "../layout/Footer/FooterOne";
import Navbar from "../layout/Header/Navbar";
import Layout from "../layout/Layout";
import {GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


const Contact = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LfWerEqAAAAAC_h_iTDZKFAfjkRog8fCigC_VLB">
      <Layout>
        <PageMeta
          title="Contact Us | SenerTech - Let's Build Your Digital Future"
          desc=""
        />
        <Navbar classOption="navbar-light" />
        <PageHeader
          title="Get in Touch Today!"
          desc="Get in touch with SenerTech for expert IT consultation, web & app development, digital marketing, and vehicle workshop software solutions. We're here to help!
          Whether you have a question, need support, or want to discuss your project, our team is ready to assist you. Fill out the contact form below or reach us through our contact details."
        />
        <ContactFormThree />
        {/* <ContactBox /> */}
        {/* <ContactFormTwo /> */}
        <FooterOne
        // style={{
        //   background:
        //     "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        // }}
        />
      </Layout>
    </GoogleReCaptchaProvider>
  );
};

export default Contact;
